import { AppContext } from '@prisjakt/ui-app-context';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'src/components/spinner';
import * as S from './styles';
import { NewsletterSignupProps } from './types';
import { useNewsletterSignup } from './useNewsletterSignup';
import { ButtonIcon, ButtonText } from '@prisjakt/ui/button/variants';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

export function NewsletterSignup(props: NewsletterSignupProps) {
  const {
    className,
    title,
    description,
    buttonText,
    buttonClass,
    stacked,
    variant = 'primary',
  } = props;
  const { t } = useContext(AppContext);
  const {
    state: { signupFeedbackTranslationKey, isSubscribed, loading },
    handleSubmit,
    handleChange,
    privacyPolicyUri,
  } = useNewsletterSignup();

  return (
    <S.NewsLetter stacked={stacked} variant={variant} className={className}>
      {title && <S.Title>{title}</S.Title>}
      {description && <S.Text>{description}</S.Text>}
      {!isSubscribed ? (
        <S.Form method="post" onSubmit={handleSubmit}>
          <S.Flex>
            <S.InlineInput
              type="email"
              name="email"
              helper={t('campaigns', signupFeedbackTranslationKey!)}
              onChange={handleChange}
              stacked={stacked}
              variant="rounded"
              placeholder={t('campaigns', 'newsletter.email-placeholder')}
              ariaLabel={t('campaigns', 'newsletter.email-input-aria-label')}
              // Do not send this element to CUX (cux.io)
              data-cux-exclude
            />
            <S.Button
              className={buttonClass || ''}
              disabled={loading}
              htmlType="submit"
            >
              {loading ? (
                <ButtonIcon>
                  <Spinner position="none" isActive={loading} />
                </ButtonIcon>
              ) : (
                <ButtonText>
                  {buttonText || t('campaigns', 'newsletter.sign-up-button')}
                </ButtonText>
              )}
            </S.Button>
          </S.Flex>
        </S.Form>
      ) : (
        <S.Text>
          <S.SubscribedCheckIcon />
          <S.SubscribeTitle>
            {t('campaigns', 'newsletter.sign-up-success')}
          </S.SubscribeTitle>
        </S.Text>
      )}
      <S.Legal>
        {privacyPolicyUri && (
          <Link
            to={privacyPolicyUri}
            // This link is nofollow to avoid it getting too much of the internal
            // pagerank (since it occurs on every page).
            rel="nofollow"
            onClick={() =>
              trackInternalNavigationClick({
                scope: InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri,
              })
            }
          >
            {t('product', 'alert.how-your-email-is-used')}
          </Link>
        )}
      </S.Legal>
    </S.NewsLetter>
  );
}
